import SomethingWentWrong from "~/app/something-went-wrong";
import { useI18n } from "~/hooks/use-i18n";

import { Button } from "../components/_deprecated/forms";
import { Box, Flex } from "../components/_deprecated/primitives";

const AnonymousErrorPage = () => {
  const { t } = useI18n("account");
  const onClick = () => {
    // use the window location so we force a refresh
    window.location.assign("/");
  };
  return (
    <Flex flexDirection="column" alignItems="center">
      <SomethingWentWrong>
        <Box mt="4" alignSelf="flex-start">
          <Button onClick={onClick}>{t("account:reset_password.back_to_login")}</Button>
        </Box>
      </SomethingWentWrong>
    </Flex>
  );
};

export default AnonymousErrorPage;
